import {
  IconGoodCause,
  IconRentStabilized,
  IconTopRated,
  IconVerified,
  IconFuture,
} from '@repo/svgs';
export {
  SuggestedLocations,
  type SuggestedAddressLocation,
  type SuggestedBoroughLocation,
  type SuggestedBuildingNameLocation,
  type SuggestedLocation,
  type SuggestedNeighborhoodLocation,
} from '@repo/utils';
import { FilterKey, BuildingStatusFilterType } from './types';

export const FILTER_ICONS = {
  verified: IconVerified,
  topRated: IconTopRated,
  rentStabilized: IconRentStabilized,
  goodCause: IconGoodCause,
  moveInDate: IconFuture,
} as const;

export const FILTER_LABELS = {
  price: 'Price',
  beds: 'Beds',
  verified: 'Verified',
  topRated: 'Top rated',
  rentStabilized: 'Rent-stabilized',
  goodCause: 'Good cause',
  moveInDate: 'Move-in',
} as const;

export const BUILDING_STATUS_FILTER_MAPPING: Record<FilterKey, BuildingStatusFilterType | null> = {
  price: null,
  beds: null,
  verified: 'isVerified',
  topRated: 'isTopRated',
  rentStabilized: 'isRentStabilized',
  goodCause: 'hasBuildingGoodCauseEviction',
  moveInDate: null,
};
